import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRouteSupplier = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem('token') &&
        localStorage.getItem('isSupplier') === 'true' ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRouteSupplier;
